export default {
    namespaced: true,

    state: {
        entity_id: '',
        currency_id: '',
        transaction_date: '',
        min_date: '',
        currency_name: '',
        currency_balance_owing_in_cents: 0,
        currency_monthly_payment_in_cents: 0,
    },

    mutations: {
        setData(state, data) {
            state.entity_id = data.institution_entity_id;
            state.currency_id = data.currency_id;
            state.transaction_date = data.from_date;
            state.min_date = data.from_date;
            state.currency_name = data.currency.currency_name;
            state.currency_balance_owing_in_cents = data.currency_balance_owing_in_cents;
            state.currency_monthly_payment_in_cents = data.currency_monthly_payment_in_cents;
        },

        reset(state) {
            state.currency_balance_owing_in_cents = 0;
        },
    },
};
